import DashboardView from "./DashboardView";

function Dashboard() {
  return <DashboardView />;
}

export default Dashboard;
